export enum PublicFormType {
  Public = 0,
  Intranet = 1
}
